import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgIllnessCough = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M19.1283 20.6483V15.9567C20.1629 14.9982 20.8845 13.7499 21.1988 12.375C21.513 11.0001 21.4054 9.56233 20.8899 8.24952C20.3744 6.93671 19.4751 5.80984 18.3093 5.01606C17.1434 4.22228 15.7654 3.79848 14.355 3.8C9.00999 3.8 7.85499 8.20167 5.94999 13.145C5.9173 13.2301 5.90579 13.3219 5.91646 13.4125C5.92713 13.503 5.95966 13.5896 6.01123 13.6648C6.06281 13.74 6.1319 13.8016 6.21255 13.8441C6.29319 13.8867 6.38297 13.909 6.47416 13.9092H7.89666V16.1592C7.89666 16.7559 8.13371 17.3282 8.55567 17.7502C8.97763 18.1721 9.54992 18.4092 10.1467 18.4092H11.2667V20.6592"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.39233 19.7742C5.47521 19.7742 5.5547 19.8071 5.6133 19.8657C5.67191 19.9243 5.70483 20.0038 5.70483 20.0867"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.08325 20.0833C5.08325 20.0004 5.11618 19.921 5.17478 19.8624C5.23339 19.8038 5.31287 19.7708 5.39575 19.7708"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.39244 20.3992C5.3514 20.3987 5.31085 20.3902 5.2731 20.3741C5.23535 20.358 5.20115 20.3346 5.17244 20.3053C5.14373 20.276 5.12108 20.2413 5.10578 20.2032C5.09048 20.1651 5.08283 20.1244 5.08327 20.0833"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.70483 20.0833C5.70483 20.1662 5.67191 20.2457 5.6133 20.3043C5.5547 20.3629 5.47521 20.3958 5.39233 20.3958"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.14575 16.9658C3.22863 16.9658 3.30812 16.9988 3.36672 17.0574C3.42533 17.116 3.45825 17.1954 3.45825 17.2783"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.83325 17.2783C2.83325 17.1954 2.86618 17.116 2.92478 17.0574C2.98339 16.9988 3.06287 16.9658 3.14575 16.9658"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.14575 17.5908C3.06287 17.5908 2.98339 17.5579 2.92478 17.4993C2.86618 17.4407 2.83325 17.3612 2.83325 17.2783"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.45825 17.2783C3.45825 17.3612 3.42533 17.4407 3.36672 17.4993C3.30812 17.5579 3.22863 17.5908 3.14575 17.5908"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.9541 16.4042C6.03698 16.4042 6.11647 16.4371 6.17507 16.4957C6.23368 16.5543 6.2666 16.6338 6.2666 16.7167"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.6416 16.7167C5.64149 16.6756 5.6495 16.6349 5.66517 16.5969C5.68083 16.559 5.70385 16.5245 5.73289 16.4954C5.76193 16.4664 5.79642 16.4434 5.83438 16.4277C5.87235 16.4121 5.91303 16.4041 5.9541 16.4042"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.9541 17.0292C5.91303 17.0293 5.87235 17.0213 5.83438 17.0056C5.79642 16.9899 5.76193 16.9669 5.73289 16.9379C5.70385 16.9088 5.68083 16.8743 5.66517 16.8364C5.6495 16.7984 5.64149 16.7577 5.6416 16.7167"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.2666 16.7167C6.2666 16.7995 6.23368 16.879 6.17507 16.9376C6.11647 16.9962 6.03698 17.0292 5.9541 17.0292"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgIllnessCough.displayName = 'SvgIllnessCough';
export default SvgIllnessCough;
